import { render, staticRenderFns } from "./editTournament.vue?vue&type=template&id=447d98ae&"
import script from "./editTournament.vue?vue&type=script&lang=js&"
export * from "./editTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports